import React, { useEffect, useState } from 'react';
import { ControlledTagAutocomplete } from './ControlledTagAutocomplete';
import { AutocompleteProps, FieldProps, Tag } from '../../types';
import { fetchTagsRequest } from '../../api/handbook';

export const qualificationRules = {
  required: 'This field is required',
};

const GROUP = 'qualification';

export const QualificationsField: React.FC<FieldProps> = ({
  margin,
  label = 'Qualification Name',
  name = 'title',
  multiple = false,
  disabled = false,
  rules = qualificationRules,
}) => {
  const [selectProps, setSelectProps] = useState<AutocompleteProps<Tag>>({
    name,
    items: [],
    rules,
    label,
    margin,
    multiple,
    disabled,
    group: GROUP,
  });

  const fetchTags = async () => {
    try {
      const res = await fetchTagsRequest({ group: GROUP, short: false });
      setSelectProps(value => ({ ...value, disabled: false, items: res.data.items }));
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    setSelectProps(value => ({ ...value, disabled: true }));
    if (!disabled) {
      fetchTags();
    }
  }, []);

  return <ControlledTagAutocomplete {...selectProps} />;
};
